export const ROTATION = 'ROTATION'
export const UNLIMITED = 'UNLIMITED'